//import React from 'react';
//import ScreenSpinner from '@vkontakte/vkui/dist/components/ScreenSpinner/ScreenSpinner';

// app
let initialState = {
	
    title: 'Arkane',     // ™®©

    locationSearch: '',
    locationHash: '',

    searchParams: {},
    hashParams: {},

    appID: 7839536,
    apiToken: null,
    apiTokenByPermission: {},

    currentWidth: 0, 
    currentHeight: 0, 

    // Flags
    appIsLoading: false,
    isMobileView: false,
}

export const appReducer = (state = initialState, action) => {

    switch (action.type) {

        case APP_SET_IS_LOADING:
            return {
                ...state,
                appIsLoading: (action.payload === true),
            };

        // Bad but Fast Practice
        case APP_UPDATE_STATE_PARAMS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            break;
    }

    return state;
}

export const APP_SET_IS_LOADING = 'APP_SET_IS_LOADING';
export const setAppIsLoading = (bool) => {
    return {
        type: APP_SET_IS_LOADING,
        payload: bool,
    };
}

// Bad but Fast Practice
export const APP_UPDATE_STATE_PARAMS = 'APP_UPDATE_STATE_PARAMS';
export const updateAppState = (newParams) => {
    return {
        type: APP_UPDATE_STATE_PARAMS,
        payload: newParams,
    };
}